import { render, staticRenderFns } from "./alerthistorylist.vue?vue&type=template&id=1d5bd21e&scoped=true&"
import script from "./alerthistorylist.vue?vue&type=script&lang=js&"
export * from "./alerthistorylist.vue?vue&type=script&lang=js&"
import style0 from "./alerthistorylist.vue?vue&type=style&index=0&id=1d5bd21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bd21e",
  null
  
)

export default component.exports